import { LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import type { InteractionMessage, InteractionResponse } from '../../core/protocol/types';
import { isInteractionPresentation } from '../../core/protocol/validators';
import { applyTheme, type ChatTheme } from '../theme';
export abstract class ToolElement extends LitElement {
  @property({ attribute: false }) interaction: InteractionMessage | null = null;
  @property({ type: Boolean }) disabled = false;
  /** Keep the options visible (disabled) when not live, instead of collapsing to the chosen answer. */
  @property({ type: Boolean }) readonly = false;
  @property({ attribute: false }) theme: ChatTheme | undefined;
  @property({ attribute: 'base-url' }) baseUrl = '';
  protected abstract readonly toolType: string;
  protected get live(): boolean { return !this.disabled && this.interaction?.interaction_status === 'pending'; }
  protected get valid(): boolean {
    const i = this.interaction;
    return !!i && i.tool_type === this.toolType && isInteractionPresentation(i, i.presentation);
  }
  protected respond(response: InteractionResponse): void {
    if (!this.interaction || !this.live || !this.valid) return;
    this.dispatchEvent(new CustomEvent('osvi-respond', { bubbles: true, composed: true, detail: { interactionId: this.interaction.interaction_id, response } }));
  }
  protected updated(changed: Map<PropertyKey, unknown>): void { if (changed.has('theme')) applyTheme(this, this.theme); }
}
